import { UploadStatus } from "../../constants/data"
import CircleIcon from "@mui/icons-material/Circle"
import {
  MarkedNoChip,
  MarkedPendingChip,
  MarkedUploadedChip,
  MarkedYesChip,
} from "../Transactions/styles"

export const StatusChip: React.FC<any> = ({ row }) => {
  const markedStatus = row.status
  switch (markedStatus) {
    case UploadStatus.SUCCESS:
      return (
        <MarkedUploadedChip
          label="Uploaded"
          size="small"
          variant="outlined"
          icon={<CircleIcon fontSize="large" />}
        />
      )
    case UploadStatus.RECONCILED:
      return (
        <MarkedYesChip
          label="Reconciled"
          size="small"
          variant="outlined"
          icon={<CircleIcon fontSize="large" />}
        />
      )
    case UploadStatus.PROCESSING:
      return (
        <MarkedPendingChip
          label="Processing"
          size="small"
          variant="outlined"
          icon={<CircleIcon fontSize="inherit" />}
        />
      )
    default:
      return (
        <MarkedNoChip
          label="Failed"
          size="small"
          variant="outlined"
          icon={<CircleIcon fontSize="inherit" />}
        />
      )
  }
}
